import StockOpenOrderRegular from '@screens/BottomContent/Stock/Order/Regular';
import StockOpenOrderDT from '@screens/BottomContent/Stock/Order/DayTrading';
import StockOpenOrderMT from '@screens/BottomContent/Stock/Order/MarginTrading';
// import StockOpenOrderBonus from '@screens/BottomContent/Stock/Order/Bonus';

import StockAutoOrderRegular from '@screens/BottomContent/Stock/AutoOrder/Regular';
import StockAutoOrderMT from '@screens/BottomContent/Stock/AutoOrder/MarginTrading';

import StockHistoryRegular from '@screens/BottomContent/Stock/History/Regular';
import StockHistoryDT from '@screens/BottomContent/Stock/History/DayTrading';
import StockHistoryMT from '@screens/BottomContent/Stock/History/MarginTrading';
// import StockHistoryBonus from '@screens/BottomContent/Stock/History/Bonus';

import MutualFundsOrder from '@screens/BottomContent/MutualFunds/Order';
import MutualFundsHistory from '@screens/BottomContent/MutualFunds/History';
import MutualFundsAutoOrder from '@screens/BottomContent/MutualFunds/AutoOrder';

const SAHAM_TAB = [
  {
    key: 'Open Order',
    name: 'Open Order',
    pills: [
      {
        label: 'Reguler',
        tableContent: StockOpenOrderRegular,
      },
      {
        label: 'Day Trading',
        tableContent: StockOpenOrderDT,
      },
      {
        label: 'Margin',
        tableContent: StockOpenOrderMT,
      },
      // {
      //   label: 'Hadiah',
      //   tableContent: StockOpenOrderBonus,
      // },
    ],
  },
  {
    key: 'Auto Order',
    name: 'Auto Order',
    pills: [
      {
        label: 'Reguler',
        tableContent: StockAutoOrderRegular,
      },
      {
        label: 'Margin',
        tableContent: StockAutoOrderMT,
      },
    ],
  },
  {
    key: 'Riwayat',
    name: 'Riwayat',
    pills: [
      {
        label: 'Reguler',
        tableContent: StockHistoryRegular,
      },
      {
        label: 'Day Trading',
        tableContent: StockHistoryDT,
      },
      {
        label: 'Margin',
        tableContent: StockHistoryMT,
      },
      // {
      //   label: 'Hadiah',
      //   tableContent: StockHistoryBonus,
      // },
    ],
  },
];

const REKSA_DANA_TAB = [
  {
    key: 'Order',
    name: 'Order',
    pills: [
      {
        label: null,
        tableContent: MutualFundsOrder,
      },
    ],
  },
  {
    key: 'Auto Beli',
    name: 'Auto Beli',
    pills: [
      {
        label: null,
        tableContent: MutualFundsAutoOrder,
      },
    ],
  },
  {
    key: 'Riwayat',
    name: 'Riwayat',
    pills: [
      {
        label: null,
        tableContent: MutualFundsHistory,
      },
    ],
  },
];

export const BOTTOM_TAB = [
  {
    key: 'Saham',
    name: 'Saham',
    tableTab: SAHAM_TAB,
  },

  {
    key: 'Reksa Dana',
    name: 'Reksa Dana',
    tableTab: REKSA_DANA_TAB,
  },
];
